import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
  Tooltip
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const EditMainCategory = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [mainCategory, setMainCategory] = useState('');
  const [description, setDescription] = useState('');

  const navigate = useNavigate();
  const { mainCategoryId } = useParams();

  // Static data for pre-fill
  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics', description: 'Electronic items and gadgets' },
    { mainCategoryId: 2, mainCategory: 'Clothing', description: 'Clothing and apparel' },
    { mainCategoryId: 3, mainCategory: 'Books', description: 'Books and literature' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen', description: 'Home and kitchen appliances' },
    { mainCategoryId: 5, mainCategory: 'Sports', description: 'Sports and outdoor equipment' },
    { mainCategoryId: 6, mainCategory: 'Toys', description: 'Toys and games' },
  ];

  useEffect(() => {
    // Simulate fetching data for the main category to edit
    const mainCategoryToEdit = staticMainCategoryData.find(data => data.mainCategoryId === parseInt(mainCategoryId));
    if (mainCategoryToEdit) {
      setMainCategory(mainCategoryToEdit.mainCategory);
      setDescription(mainCategoryToEdit.description);
    }
  }, [mainCategoryId]);

  const handleSave = (e) => {
    e.preventDefault();
    if (mainCategory && description) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Main Category
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <TextField
            label="Main Category"
            variant="outlined"
            fullWidth
            value={mainCategory}
            onChange={(e) => setMainCategory(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!mainCategory ? "Enter Main Category" : !description ? "Enter Description" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Main Category Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Main Category Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditMainCategory;
